// SheetJS 지연 로드 — xlsx 의존은 core 에만 있어 web 이 직접 import("xlsx") 하면 풀리지 않으므로 여기서 받는다(누를 때만 받는다).
export const loadXlsx = () => import("xlsx");
